import { render, staticRenderFns } from "./NewHelpList.vue?vue&type=template&id=1350bf2f&"
import script from "./NewHelpList.vue?vue&type=script&lang=js&"
export * from "./NewHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports